import { render } from "./Cooperate.vue?vue&type=template&id=5da370a9&scoped=true"
const script = {}

import "./Cooperate.vue?vue&type=style&index=0&id=5da370a9&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da370a9"]])

export default __exports__